import React from 'react';
import { observer } from 'mobx-react';
import { PaymentStore } from '@seedlang/stores';
import InPlaceText from 'components/form/in_place_text';
import InPlaceDatePicker from 'components/form/in_place_date_picker';
import autobind from 'autobind-decorator';
import { Link } from 'react-router';
import Button from 'components/button/button';
import Stack from 'components/layout/stack';
import Grid from 'components/layout/grid';

@observer
class PaymentEdit extends React.Component {

  componentDidMount() {
    this.getPayment();
  }

  @autobind getPayment() {
    PaymentStore.getShow({ ids: {paymentId: this.props.params.paymentId }});
  }

  render() {
    return (
      <Stack gap='sm' alignItems='stretch'>
        {
          this.props.params.subscriptionId &&
            <Link
              to={{name: 'builder.subscriptions.edit', params: {subscriptionId: this.props.params.subscriptionId}}}
              className='underline'
            >
              <i className='fa fa-caret-left' />
              Return to Subscription
            </Link>
        }
        <Grid columns={3}>
          <InPlaceText
            legend='Amount'
            defaultValue={PaymentStore.showDataField('amount')}
            model='payments'
            field='amount'
            id={PaymentStore.showDataField('id')}
            afterChange={this.getPayment}
          />
          <InPlaceText
            legend='Currency'
            defaultValue={PaymentStore.showDataField('currency')}
            model='payments'
            field='currency'
            id={PaymentStore.showDataField('id')}
            afterChange={this.getPayment}
          />
          <InPlaceDatePicker
            legend='Occurred At'
            value={PaymentStore.showDataField('occurredAt')}
            model='payments'
            field='occurredAt'
            id={PaymentStore.showDataField('id')}
            afterChange={this.getPayment}
          />
          <InPlaceDatePicker
            legend='Refunded At'
            value={PaymentStore.showDataField('refundedAt')}
            model='payments'
            field='refundedAt'
            id={PaymentStore.showDataField('id')}
            afterChange={this.getPayment}
          />
          <fieldset>
            <legend>Transaction Id</legend>
            <InPlaceText
              defaultValue={PaymentStore.showDataField('transactionId')}
              model='payments'
              field='transactionId'
              id={PaymentStore.showDataField('id')}
            />
            {
              PaymentStore.showDataField('transactionId') && PaymentStore.showDataField('transactionId').match(/^ch_/) &&
                <a
                  href={`https://dashboard.stripe.com/payments/${PaymentStore.showDataField('transactionId')}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Button
                    style={{marginTop: 10}}
                  >
                    Open on Stripe
                  </Button>
                </a>
            }
          </fieldset>
        </Grid>
      </Stack>
    );
  }
}

export default PaymentEdit;
